// TODO: JB(timeline-redesign): once the old AI component is erase remove old keys from intl file
import {
  Box,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
  makeStyles,
} from '@material-ui/core';
import {
  ChevronRightRounded,
  EditRounded,
  MicNoneRounded,
  MicRounded,
  ShortTextRounded,
  SubjectRounded,
  TranslateRounded,
} from '@material-ui/icons';
import { parseMessage } from '@src/locales/intl';
import { fetchTransformTextAI } from '@src/reducers/chats';
import { CommandAIEnum, LanguageEnum } from '@src/types';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import AIButton from './AIButton';

export const boxCss = {
  display: 'flex',
  gridGap: '5px',
  alignItems: 'center',
  padding: '2px 0',
};

export const BG_GRAY = '#F4F4F5';

const useStyles = makeStyles(theme => ({
  paper: {
    margin: '-7px 0',
    boxShadow: '0px 0px 10px 2px rgba(0, 0, 0, 0.4)',
  },
  language: {
    boxShadow: '0px 0px 10px 2px rgba(0, 0, 0, 0.4)',
    margin: '5px',
  },
  menuList: {
    background: theme.palette.background.paper,
    color: theme.palette.text.primary,
    '& .MuiMenuItem-root:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  menuHeader: {
    padding: '10px',
    color: theme.palette.text.secondary,
    fontSize: '0.85rem',
  },
}));

const languages = Object.keys(LanguageEnum).map(key => ({
  name: parseMessage(`Chat.AI.Translate.${key}`),
  code: LanguageEnum[key as keyof typeof LanguageEnum],
}));

export interface IImproveTextAI {
  disabled: boolean;
}

export const ImproveTextAI: React.FC<IImproveTextAI> = ({ disabled }) => {
  const [anchorAI, setAnchorAI] = useState<HTMLElement | null>(null);
  const [anchorLanguage, setAnchorLanguage] = useState<HTMLElement | null>(
    null
  );
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    const { currentTarget } = event;
    if (currentTarget.localName === 'button') {
      setAnchorAI(currentTarget);
    } else {
      setIsOpen(true);
      setAnchorLanguage(currentTarget);
    }
  };

  const handlePopoverClose = (
    _event: React.MouseEvent<HTMLElement, MouseEvent>,
    reason: string
  ) => {
    if (reason === 'backdropClick') {
      if (isOpen) {
        setAnchorLanguage(null);
        setIsOpen(false);
      } else {
        setAnchorLanguage(null);
        setAnchorAI(null);
      }
    }
  };

  const onTranslate = (language: string) => {
    setAnchorLanguage(null);
    setAnchorAI(null);
    setIsOpen(false);
    dispatch(
      fetchTransformTextAI({
        command: CommandAIEnum.TRANSLATE,
        language,
      })
    );
  };

  const onCommand = (command: CommandAIEnum) => {
    setAnchorAI(null);
    dispatch(fetchTransformTextAI({ command: command.toString() }));
  };

  const open = Boolean(anchorAI);
  const openLanguages = Boolean(anchorLanguage);
  const { paper, language, menuList, menuHeader } = useStyles();

  return (
    <>
      <Popover
        id="popover-languages"
        open={openLanguages}
        anchorEl={anchorLanguage}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          classes: { root: language },
        }}
        onClose={handlePopoverClose}
      >
        <MenuList className={menuList}>
          {languages.map(item => (
            <MenuItem key={item.code} onClick={() => onTranslate(item.code)}>
              <ListItemText primary={item.name} />
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
      <Popover
        id="popover-ai"
        open={open}
        anchorEl={anchorAI}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          classes: { root: paper },
        }}
        onClose={handlePopoverClose}
      >
        <MenuList className={menuList}>
          <Box className={menuHeader}>
            {parseMessage('Chat.AI.EditReviewSelecion')}
          </Box>
          <MenuItem onClick={() => onCommand(CommandAIEnum.IMPROVE)}>
            <Box sx={boxCss}>
              <EditRounded fontSize="small" />
              {parseMessage('Chat.AI.ImproveWriting')}
            </Box>
          </MenuItem>
          <MenuItem onClick={handlePopoverOpen}>
            <Box
              display="flex"
              width="100%"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box sx={boxCss}>
                <TranslateRounded fontSize="small" />
                {parseMessage('Chat.AI.Translate')}
              </Box>
              <ChevronRightRounded fontSize="small" />
            </Box>
          </MenuItem>
          {[
            {
              command: CommandAIEnum.LONGER,
              icon: <SubjectRounded fontSize="small" />,
            },
            {
              command: CommandAIEnum.SHORTER,
              icon: <ShortTextRounded fontSize="small" />,
            },
            {
              command: CommandAIEnum.CASUAL,
              icon: <MicRounded fontSize="small" />,
            },
            {
              command: CommandAIEnum.FORMAL,
              icon: <MicNoneRounded fontSize="small" />,
            },
          ].map(({ command, icon }) => (
            <MenuItem key={command} onClick={() => onCommand(command)}>
              <Box sx={boxCss}>
                {icon}
                {parseMessage(`Chat.AI.${command}`)}
              </Box>
            </MenuItem>
          ))}
        </MenuList>
      </Popover>

      <AIButton
        label={parseMessage('Chat.AI.IconButtonLabel')}
        size="small"
        onClick={handlePopoverOpen}
        disabled={disabled}
      />
    </>
  );
};

export default ImproveTextAI;
